module.exports = __webpack_public_path__ + "img/platform_02_notificatie.493f0154.png";